<div class="main" *ngIf="firstName">
      <div class="row">
        <div class="col-xs-12 spacing">
          <app-home-base></app-home-base>
    </div>
  </div>
</div>
